import { api, apiFormData } from "./base.api.ts"

export const uploadImageForProfile = async ({
  image,
  userType,
}: {
  image: {
    id: string
    name: string
    type: string
    uri: string
    uploaded: boolean
    deleted: boolean
  }
  userType: string
}) => {
  if (image?.uploaded) {
    return image.uri
  }
  const imageFormData = new FormData()
  imageFormData.append(
    "image",
    JSON.stringify({
      name: "profilePic",
      type: "image/jpg",
      uri: image.uri,
    })
  )
  imageFormData.append("file", image.uri)
  imageFormData.append("type", "profile")
  imageFormData.append("user_type", userType)

  const res = await apiFormData.post("upload-file", imageFormData)
  return res.data.data.Location
}

export const uploadImageForGallery = async (image: {
  id: string
  name: string
  type: string
  uri: string
  uploaded: boolean
  deleted: boolean
}) => {
  const imageFormData = new FormData()
  imageFormData.append(
    "image",
    JSON.stringify({
      name: "galleryImage",
      type: image.type,
      uri: image.uri,
    })
  )
  imageFormData.append("file", image.uri)
  imageFormData.append("type", "gallery")

  const res = await apiFormData.post("upload-file", imageFormData)
  return res.data.data.Location
}

export const deleteImage = async (
  image: {
    id: string
    name: string
    type: string
    uri: string
    uploaded: boolean
    deleted: boolean
  },
  type
) => {
  const idx1 = image.uri?.lastIndexOf("/")
  const uploadUri = image.uri?.slice(idx1 + 1)
  await api.post("delete-file", {
    key: uploadUri,
    type: "gallery",
  })
}
